/**
 * @generated SignedSource<<348a32b79e58c4213ba90945a2584618>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonPlannerMenu_project$data = {
  readonly id: number;
  readonly name: string;
  readonly project_workstreams: ReadonlyArray<{
    readonly workstream_id: number;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ChangeProjectRoleModal_project" | "ChangeWorkstreamModal_project" | "RemoveMembershipFromProjectMenuItem_project">;
  readonly " $fragmentType": "PersonPlannerMenu_project";
};
export type PersonPlannerMenu_project$key = {
  readonly " $data"?: PersonPlannerMenu_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonPlannerMenu_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonPlannerMenu_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "project_workstreams",
      "kind": "LinkedField",
      "name": "project_workstreams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workstream_id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChangeProjectRoleModal_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoveMembershipFromProjectMenuItem_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChangeWorkstreamModal_project"
    }
  ],
  "type": "projects",
  "abstractKey": null
};

(node as any).hash = "fd4f95d9ef0180b464cbd7fe116aa7c5";

export default node;
